import { ErrorPageType } from '@grouper/modules/core/errorPageTypes'
import PublicSiteErrorPage from '@grouper/modules/builder/components/PublicSiteErrorPage'

export class PublicSiteErrorPageType extends ErrorPageType {
  getComponent() {
    return PublicSiteErrorPage
  }

  isApplicable() {
    return (
      this.app.$router.currentRoute.value.name === 'application-builder-page' ||
      this.app.$router.currentRoute.value.name === 'application-builder-preview'
    )
  }

  static getType() {
    return 'publicSite'
  }

  getOrder() {
    return 10
  }
}
